<template>
    <PageContent type="center" :compClass="'flex flex-col space-y-6'">
      <div class="flex flex-row items-center justify-between">
        <h1 class="text-xl font-semibold">Agreement Information</h1>
      </div>
  
      <div>
        Info
      </div>

    </PageContent>
  </template>
  
  <script>
  import * as Config from "@/config";
  import PageContent from "@/components/PageContent";
  
  export default {
    name: "AdminHome",
    data() {
      return {
        creditAgreementInformation: null
      };
    },
    components: {
      PageContent,
    },
    mounted() {
      this.getCurrentAgreementInformattion();
    },
    methods: {
      async getCurrentAgreementInformattion() {
        let res = await this.$http.get(
          Config.apiPath + "/api/v2/admin/credits/agreement/" + this.$route.params.id
        );
        this.creditAgreementInformation = res.data;
      },
    },
  };
  </script>
  
  